import {
  defaultTtsVoice,
  DesignLanguage,
  LanguageCode,
  TextToSpeechVoiceOrDefault,
  Voice
} from '@app/types';

export type LanguageMatchProps = {
  languageCode: LanguageCode;
  ttsVoice: TextToSpeechVoiceOrDefault;
  /** When set (including `null`), VT must match. When omitted, VT is ignored. */
  voice?: Voice | null;
};

/** True when a design language entry matches language + TTS, and VT when provided. */
export function isLanguageMatch(
  entry: DesignLanguage,
  {
    languageCode,
    ttsVoice,
    voice
  }: LanguageMatchProps
): boolean {
  return (
    entry.language === languageCode
    && (entry.ttsFallBackVoice ?? defaultTtsVoice) === ttsVoice
    && (
      voice === undefined
      || (entry.voice || '') === (voice || '')
    )
  );
}
